import { useState,useEffect } from "react";
import { BrowserRouter, Route, Switch, Redirect, useHistory,Link,useParams } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalBody,
} from "reactstrap";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';

import '../../../assets/css/custom.css';
import Header from "components/Headers/Header.js";
import { ToastContainer, toast } from "react-toastify";
import { usermanageService } from "../../../services/usermanageService";
import { clientmanageService } from "../../../services/clientmanageService.js";
import Paginationcomponent from "components/Paginationcomponent.js"
import Select from 'react-select';
 const RoleLog = (props) => {
 const params  = useParams();
 const history = useHistory();
 const [logdata, setlogData] = useState([]);
 const [currentPage, setCurrentPage] = useState(null);
 const [last_page, setLastPageData] = useState(0);
 const [error, setError] = useState(null)
 const [statuslist, setStatusdata] = useState([]);
const [successMsg, setsuccessMsg] = useState(null)
const [rowsPerPage, setRowsPerPage] = useState(25);
const [total_page,setTotalData] = useState(0);
const rowsPerPageOptions = [5, 10, 25, 50, 100];
  
  const errorDiv = error 
        ? <UncontrolledAlert className="alert-danger" fade={false}>
        {error}
        </UncontrolledAlert> 
        : '';
  const successDiv = successMsg 
        ? <UncontrolledAlert className="alert-success" fade={false}>
        {successMsg}
        </UncontrolledAlert> 
        : '';
  useEffect(()=>{
     get_unique_userslist()
    getRolelog()
  },[]);
  const [sortfield,setsortfield] = useState('');
  const [sortorder,setsortorder] = useState('asc');
  const [userslist, setUsersData] = useState([]);
  function get_unique_userslist(){
    clientmanageService.getusers().then((response) => {
      setUsersData(response.data)
    });
  }
  function sortTable(field){
    console.log(field)
    setsortfield(field);
    if(sortorder=='asc'){
      setsortorder('desc');
    }else{
      setsortorder('asc');
    }
  }
  const handlePageClick = (e, index) => {
    e.preventDefault();
    getRolelog(index,rowsPerPage);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    getRolelog(prev,rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    getRolelog(next,rowsPerPage);
  };
  const getRolelog = async (pageNumber = 1,rowsPerPage='',user_id='') => { 
    
    usermanageService.getRolelog(pageNumber,rowsPerPage,user_id).then((response) => {
      console.log(response.data.data); 
        setlogData(response.data.data); 
         setCurrentPage(response.data.current_page);
         setLastPageData(response.data.last_page);
         setTotalData(response.data.total);
    });
  };
  function downloadReport(){
    
    clientmanageService.clienttransitionlogexport().then((response) => {
    
    });
  }
const user_info = JSON.parse(localStorage.getItem("user-info"));
const handleRowsPerPageChange = (newRowsPerPage) => {

    setRowsPerPage(newRowsPerPage);
    
    setCurrentPage(1); 
    getRolelog(1,null,newRowsPerPage)
  
  };
const [selecteduser,setSelectedUser]=useState("");
const setUser = (e)=>{
  let user = [];

    setSelectedUser(e.value);        // Update selected user state with the array of values
   
  getRolelog(1,rowsPerPage,e.value)
} 
const add_role_change_log = ()=>{
  history.push({
    pathname: 'add_role_change_log',
  });

}
return (
    <>
      <Header />
      {/* Page content */}
        <Container className="mt--7" fluid>
        <div className="row">
            <div className="col-xl-12">
           <div className="col-md-12 col-12 mb-2">
              <Button className="col-2 " color="primary" onClick={add_role_change_log}>
                          Add role change log
                        </Button>
            </div>
            <Row>
            
              <Col xl="12">
                <Card className="shadow">
                  <CardHeader className="bg-transparent">
                    <Row className="align-items-center">
                      <div className="col">
                        <h4 className="text-uppercase text-muted ls-1 mb-1">
                          Role Log
                        </h4>
                      </div>
                      <div className="col-xl-3" >
                        {(userslist && userslist.length > 0) ? 
                                        <Select 
                                        
                                        className="input-group-alternative " 
                                        name="user_id"
                                        options={userslist} // set list of the data
                                        onChange={(e) => setUser(e,'user_id')}
                                        //  value={usersearch}
                                        searchable
                                        isClearable={false}
                                        
                                        />
                                        : null }
                                        
                        </div>
                      <div>
                      {/* <Button
                      className="btn-icon-clipboard"
                      type="button"
                      onClick={downloadReport}
                      style={{textAlign:'center'}}
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                    </Button> */}
                      </div>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <th scope="col" className="whitespace" >User Name</th>
                    <th scope="col" className="whitespace" >Role Name</th>
                    <th scope="col" className="whitespace">From Date</th>
                    <th scope="col" className="whitespace">To Date</th>
                  </thead>
                <tbody>
                  {logdata &&
                    logdata.length &&
                    logdata != null ? (
                        logdata.map((item, i) => (
                      <>
                      <tr className={((i % 2 == 0)? 'blue-row':(i % 3 == 0)?'purple-row':'orange-row') } >
                          <td className="whitespace">{item.user_name}</td>
                          <td className="whitespace">{item.role_name}</td>
                          <td className="whitespace">{item.from_date}</td>
                          <td className="whitespace">{item.to_date}</td>
                      </tr>
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
                    </Table>
                    <CardFooter className="py-4">
               <div>
     
                    <Paginationcomponent
                currentPage={currentPage}
                totalItems={total_page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={rowsPerPageOptions}
                handlePageClick={handlePageClick}
                handlePreviousClick={handlePreviousClick}
                handleNextClick={handleNextClick}
                handleRowsPerPageChange={handleRowsPerPageChange}
                />
                      </div>
              </CardFooter>
                </Card>
              </Col>
             
            </Row>
             
            </div>
        </div>

        <Row>
        
        </Row>
      </Container>
    </>
  );
};
export default RoleLog;
